// Variant titles that are Shopify placeholders, not meaningful product attributes.
// Mirrors backend IGNORED_VARIANT_TITLES in shopify_app/services/initial_sync.py.
const IGNORED_VARIANT_TITLES = new Set([
  'default title', 'default', 'default variant',
  'standard', 'one size', 'no variant',
]);

/** Returns true if the variant title is a Shopify placeholder (case-insensitive). */
export function isIgnoredVariantTitle(value) {
  if (!value) return true;
  return IGNORED_VARIANT_TITLES.has(value.trim().toLowerCase());
}

/** Returns the variant title for display, or '' if it's a placeholder. */
export function getVariantTitle(value) {
  if (!value) return '';
  const trimmed = value.trim();
  return IGNORED_VARIANT_TITLES.has(trimmed.toLowerCase()) ? '' : trimmed;
}
